import React from "react";
import "../scss/hero.scss";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero_content">
        <div className="hero_content_heading">
          <h1>Hi. I'm Vikas</h1>
        </div>
        <p>
          a Designer <br />
          and a Full-stack Developer
        </p>
        <a className="downloadBtn" href="/docs/full_stack_developer_vikas.pdf" download>
          Download CV <i className="fa-solid fa-file-arrow-down"></i>
        </a>
      </div>
    </section>
  );
};

export default Hero;
